/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { createBigNumberClass } from '../../factoriesAny.js';
export var BigNumberDependencies = {
  createBigNumberClass
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesBigNumberClass.generated.js
// module id = 6
// module chunks = 2